module.exports = __webpack_public_path__ + "img/mobile_type_three.dccfc005.png";